import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
    news: {

    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/news/index.js